// import React from "react";
// import { InView } from "react-intersection-observer";
// import "../styles/Hero.css";
// import OnBackgroundIcons from "../../assets/on-background-icons.svg";

// const Hero = () => {
//   return (
//     <div>
//       <section
//         className="heros-section-custom"
//         role="banner"
//         aria-labelledby="heros-title"
//       >
//         <div className="heros-custom-content-container">
//           <InView triggerOnce={true} threshold={0.1}>
//             {({ inView, ref }) => (
//               <header
//                 ref={ref}
//                 className={`heros-custom-content ${inView ? "animate" : ""}`}
//               >
//                 <h1 id="heros-title">Microsoft 365 Services</h1>
//               </header>
//             )}
//           </InView>
//         </div>
//       </section>
//       <section
//         className="hero-section section-spacing"
//         role="banner"
//         aria-labelledby="hero-title"
//       >
//         <div className="hero-content-container">
//           <InView triggerOnce={true} threshold={0.1}>
//             {({ inView, ref }) => (
//               <header
//                 ref={ref}
//                 className={`hero-content ${inView ? "animate" : ""}`}
//               >
//                 <h1 id="hero-title">Microsoft 365 Services</h1>
//                 <p>
//                   Microsoft is redefining business productivity with Microsoft
//                   365 — an AI-powered, secure, and fully integrated cloud
//                   platform. With tools like{" "}
//                   <abbr title="Microsoft Copilot">Copilot</abbr>,{" "}
//                   <abbr title="Microsoft Teams">Teams</abbr>,{" "}
//                   <abbr title="Power Business Intelligence">Power BI</abbr>,{" "}
//                   <abbr title="Microsoft SharePoint">SharePoint</abbr>, and{" "}
//                   <abbr title="Microsoft Azure">Azure</abbr>, organizations
//                   unlock smarter collaboration and deeper insights.
//                 </p>
//               </header>
//             )}
//           </InView>
//           <InView triggerOnce={true} threshold={0.1}>
//             {({ inView, ref }) => (
//               <aside
//                 ref={ref}
//                 className={`hero-icons ${inView ? "animate" : ""}`}
//                 aria-label="Microsoft 365 Services Visual Representation"
//               >
//                 <figure>
//                   <img
//                     src={OnBackgroundIcons}
//                     alt="Illustration showing Microsoft 365 services including Copilot, Teams, Power BI, SharePoint, and Azure represented as interconnected icons"
//                     aria-describedby="hero-title"
//                   />
//                 </figure>
//               </aside>
//             )}
//           </InView>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Hero;








import React from "react";
import { InView } from "react-intersection-observer";
import "../styles/Hero.css";
import OnBackgroundIcons from "../../assets/on-background-icons.svg";

const Hero = () => {
  return (
    <>
      {/* 1. Background Banner Section */}
      <section
        className="heros-section-custom"
        role="banner"
        aria-labelledby="heros-title"
      >
        {/* Renamed class */}
        <div className="m365-banner-container">
          <InView triggerOnce={true} threshold={0.1}>
            {({ inView, ref }) => (
              <header
                ref={ref}
                className={`heros-custom-content ${inView ? "animate" : ""}`}
              >
                <h1 id="heros-title">Microsoft 365 Services</h1>
              </header>
            )}
          </InView>
        </div>
      </section>

      {/* 2. Main Content Section */}
      <section
        className="m365-hero-section section-spacing" // Renamed class
        role="banner"
        aria-labelledby="hero-title"
      >
        {/* Renamed class to avoid conflicts */}
        <div className="m365-hero-container">
          
          {/* Text Content */}
          <InView triggerOnce={true} threshold={0.1}>
            {({ inView, ref }) => (
              <header
                ref={ref}
                className={`m365-hero-text ${inView ? "animate" : ""}`} // Renamed class
              >
                <h1 id="hero-title">Microsoft 365 Services</h1>
                <p>
                  Microsoft is redefining business productivity with Microsoft
                  365 - an AI-powered, secure, and fully integrated cloud
                  platform. With tools like{" "}
                  <abbr title="Microsoft Copilot">Copilot</abbr>,{" "}
                  <abbr title="Microsoft Teams">Teams</abbr>,{" "}
                  <abbr title="Power Business Intelligence">Power BI</abbr>,{" "}
                  <abbr title="Microsoft SharePoint">SharePoint</abbr>, and{" "}
                  <abbr title="Microsoft Azure">Azure</abbr>, organizations
                  unlock smarter collaboration and deeper insights.
                </p>
              </header>
            )}
          </InView>

          {/* Right Image */}
          <InView triggerOnce={true} threshold={0.1}>
            {({ inView, ref }) => (
              <aside
                ref={ref}
                className={`m365-hero-icons ${inView ? "animate" : ""}`} // Renamed class
                aria-label="Microsoft 365 Services Visual Representation"
              >
                <figure>
                  <img
                    src={OnBackgroundIcons}
                    alt="Microsoft 365 services icons illustration"
                    aria-describedby="hero-title"
                  />
                </figure>
              </aside>
            )}
          </InView>
        </div>
      </section>
    </>
  );
};

export default Hero;